import React from 'react';
import { useCommonModal } from 'contexts/ModalContext';
import TooManyPendingOffersModal from './TooManyPendingOffersModal';

const ModalView = () => {
  const { showTooManyPendingOfferModal, setShowTooManyPendingOfferModal, modalArgs } = useCommonModal();

  const handleCloseTooManyPendingModal = () => {
    setShowTooManyPendingOfferModal(false);

    if (typeof modalArgs?.onCloseCallback === 'function') {
      modalArgs.onCloseCallback();
    }
  };

  return (
    <>
      <TooManyPendingOffersModal
        isModalOpen={showTooManyPendingOfferModal}
        onClose={handleCloseTooManyPendingModal}
        source={modalArgs?.source}
        type={modalArgs?.type}
      />
    </>
  );
};

export default ModalView;
